import { Tooltip } from 'antd';
import classnames from 'classnames';
import React from 'react';
import styles from './ellipsis.module.scss';
export const EllipsisText = ({ text, footerLength, tooltip = true, className, tipsZIndex }) => {
    const safeText = text !== null && text !== void 0 ? text : '';
    const normalizedFooterLength = Math.max(0, Math.min(footerLength, safeText.length));
    if (normalizedFooterLength === 0 || normalizedFooterLength >= safeText.length) {
        const inner = React.createElement("div", { className: classnames([className, styles.ellipsis]) }, safeText);
        if (tooltip) {
            return (React.createElement(Tooltip, { title: safeText, zIndex: tipsZIndex }, inner));
        }
        return inner;
    }
    const text1 = safeText.substring(0, safeText.length - normalizedFooterLength);
    const text2 = safeText.substring(safeText.length - normalizedFooterLength);
    const inner = (React.createElement("div", { className: classnames([className, styles.ellipsisWrap]) },
        React.createElement("span", { className: styles.ellipsis }, text1),
        React.createElement("span", { className: styles.indent }, text2)));
    if (tooltip) {
        return (React.createElement(Tooltip, { title: safeText, zIndex: tipsZIndex }, inner));
    }
    return inner;
};
